import React from 'react';
import styled from 'styled-components';
import EmailOptInImage from '@99designs/apps/spa/images/auth/email-opt-in.jpg';
import { Box, Stack } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { DesignerAttribution } from '../Designer/DesignerAttribution';
import { MarketingOptInCheckbox, MarketingOptInCheckboxProps } from './MarketingOptInCheckbox';
import { MarketingOptInHeader, MarketingOptInHeaderProps } from './MarketingOptInHeaders';

const cardBackgroundColor = '#F3F6FB';

const imageWidth = 181;

const Figure = styled.figure`
    position: relative;
    min-width: ${imageWidth - 20}px;

    ${mediaQuery.only('small')} {
        display: none;
    }
`;

const PositionAndSizeFigure = styled(Box)`
    width: ${imageWidth}px;

    position: absolute;
    bottom: -${spaces['2bu']};
`;

const Attribution = styled.figcaption`
    text-align: right;
    padding-right: ${spaces['1bu']};
`;

const StyledCard = styled.div`
    background-color: ${cardBackgroundColor};
    border-radius: ${spaces['1bu']};
    padding: ${spaces['1.5bu']};

    max-width: 605px;
    overflow: hidden;
`;

function MarketingOptInFigure() {
    return (
        <Figure>
            <PositionAndSizeFigure>
                <Attribution>
                    <DesignerAttribution
                        openInNewTab
                        name="Spoon Lancer"
                        link="/profiles/SpoonLancer"
                    />
                </Attribution>
                <img
                    src={EmailOptInImage}
                    alt={formatMessage(__('Design by {displayName}'), {
                        displayName: 'Spoon Lancer',
                    })}
                />
            </PositionAndSizeFigure>
        </Figure>
    );
}

export const MarketingOptInInformationCard = React.forwardRef<
    HTMLInputElement,
    MarketingOptInCheckboxProps & MarketingOptInHeaderProps
>(function ({ userRole, ...checkboxProps }, ref) {
    return (
        <StyledCard>
            <Box display="flex" justifyContent="center" flexDirection="row">
                <Box width="100%">
                    <Stack space="1bu">
                        <MarketingOptInHeader userRole={userRole} headingSize="small" />
                        <MarketingOptInCheckbox userRole={userRole} ref={ref} {...checkboxProps} />
                    </Stack>
                </Box>

                <MarketingOptInFigure />
            </Box>
        </StyledCard>
    );
});
